export const release = "7554310e9592bc2d7681091794525797992adda5";
